import { render, staticRenderFns } from "./pageFooter.vue?vue&type=template&id=6722cf6c&"
import script from "./pageFooter.vue?vue&type=script&lang=js&"
export * from "./pageFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports